<template>
  <createContent/>
</template>

<script>
// import createContent from '@/components/_manageemployee/_update/update.vue' // เก่า
import createContent from '@/components/_manageemployee/_update/updateNew.vue' // ใหม่
export default {
  components: {
    createContent
  }
}
</script>
